import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  data: {},
};

export const consultantSwitchSlice = createSlice({
  name: "switch",
  initialState,
  reducers: {
    setConsultantSwitch: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
  },
});

export const { setConsultantSwitch } = consultantSwitchSlice.actions;
export default consultantSwitchSlice.reducer;
